<template>
	<div class="fixed inset-0 flex items-center justify-center bg-trans-gray z-20" v-show="show">
		<div class="rounded shadow bg-white w-full max-h-screen mx-1 sm:w-1/2">
			<div class="rounded-t bg-gray-800 px-4 py-4 text-white font-thin text-lg">
				Bulk order
			</div>
			<div class="p-4 overflow-auto" style="max-height: 80vh">
				<div class="space-y-2" v-if="fetchedProducts">
					<div class="p-4 bg-gray-100 rounded" v-for="(products, supplier) in fetchedProducts">
						<h2 class="font-bold text-black">{{ supplier }}</h2>
							<div class="mb-2 flex items-center px-2">
								<div class="flex-1 mr-2">
									
								</div>
								<div class="mr-2 w-24">
									forecast qty
								</div>
								<div class="mr-2 w-24">
									bulk qty
								</div>
								<div class="mr-2 w-24 text-right">
									total
								</div>
							</div>
						<template v-for="(product, i) in products">
							<div class="mb-2 flex items-center px-2" :key="i">
								<div class="flex-1 mr-2">
									<p class="">{{ product.name }}</p>
								</div>
								<div class="w-24 mr-2">
									{{ product.ordered_qty }}
								</div>
								<div class="mr-2">
									<input class="w-24 appearance-none border rounded py-2 px-3 leading-tight focus:outline-none focus:shadow-outline" type="number" v-model="product.qty" placeholder="qty">
								</div>
								<div class="w-24 mr-2 text-right">
									{{Number(product.ordered_qty) + Number(product.qty)}}
								</div>
							</div>
						</template>
					</div>
					<p class="text-red-500 text-xs italic mt-1 px-2" v-if="errors.qty">Please check quantities</p>
				</div>
			</div>
			<div class="rounded-b bg-gray-200 px-4 py-2">
				<div class="flex items-center justify-between">
					<action-button class="link" @button-clicked="cancel">cancel</action-button>
					<action-button class="btn btn-blue" @button-clicked="save">Save</action-button>
				</div>
			</div>
		</div>
	</div>
</template>

<script>

export default {
	props: ['show','regionid'],
	data () {
		return {
			errors: {
				product_id: false,
				qty: false,
				comment: false,
			},
			details: {
				comment: '',
				type: '',
				placed_by: ''
			},
			fetchedProducts: [],
			products: [],
			selected: null,
      		searchText: '',
		}
	},
	methods: {
		checkForErrors () {
			if(this.details.comment == String(this.details.comment).trim() === ''){
				this.errors.comment = true;
			}else{
				this.errors.comment = false;
			}
			let productErrors = this.products.filter(product => {
				return product.qty == '' ||  product.qty == null;
			});
			if(productErrors.length){
				this.errors.qty = true;
			}else{
				this.errors.qty = false;
			}
			return Object.values(this.errors).filter(error => {
				return error === true;
			}).length;
		},
		cancel () {
			this.$emit('close')
		},
		save () {
			if (this.checkForErrors()) return;
			// console.log(this.product);
			// return;
			let filteredProducts = this.$_.flatMap(this.fetchedProducts, (products) => {
				return this.$_.filter(products, (product) => {
					return product.qty;
				});
			});
			console.log(filteredProducts);
			this.$http.post(`forecasts/${this.regionid}/bulk_orders/`, {
					'products': filteredProducts,
				})
				.then(response => {
					let success = {
						title: 'Action Successful',
						message: 'Bulk saved successfully!',
						type: 'success'
					}
					this.$store.commit('setStatus', success)	
					this.$emit('reload')
					this.$emit('close')
				})
				.catch(err => {
					this.error = err
				})
		}
	},
	computed: {
		
	},
	components: {
	},
	watch: {
		show: {
			immediate: true,
			handler: show => {
				if (show) {
					document.body.style.setProperty('overflow', 'hidden')
				} else {
					document.body.style.removeProperty('overflow')
				}
			}
		}
	},
	created () {
		const listener = document.addEventListener('keydown', e => {
			if (this.show && e.keyCode === 27) {
				this.cancel()
			}
		})

		this.$once('hook:beforeDestroy', () => {
			document.removeEventListener('keydown', listener)
			document.body.style.removeProperty('overflow')
		});

		this.$http.get(`/forecasts/${this.regionid}/products_available_for_bulk`).then((response) => {
			this.fetchedProducts = response.data.products;
		})
	}
}
</script>
